import * as React from 'react';
import { CircularProgress } from '@mui/material';

import { Appointment, Container } from 'types/Watchlist';
import { getAppointmentStatus, getPickupAppointmentAvilabilityRefreshing } from '../utility';
import { ContainerAppointmentsContext, TriggerPickupAppointmentsContext } from '../../context';
import { Scheduled } from './Scheduled';
import { Book } from './Book';

interface Props {
  container: Container;
}

export const ScheduleUpdateIndicator: React.FC<Props> = (props) => {
  const { container } = props;
  const { appointments } = React.useContext(ContainerAppointmentsContext);
  const { triggerPickupAppointments } = React.useContext(TriggerPickupAppointmentsContext);

  const appointment: Appointment | undefined = appointments[container.containerNumber];
  if (!appointment) {
    return null;
  }

  const isRefreshing = getPickupAppointmentAvilabilityRefreshing(
    appointment,
    triggerPickupAppointments[container.containerNumber.toLowerCase()]
  );
  return isRefreshing ? (
    <h6>
      <CircularProgress size={10} />
      REFRESHING APPOINTMENTS...
    </h6>
  ) : null;
};
ScheduleUpdateIndicator.displayName = 'ContainerTable.PickupCell.ScheduleUpdateIndicator';

export const Schedule: React.FC<Props> = (props) => {
  const { container } = props;

  const { appointments, status } = React.useContext(ContainerAppointmentsContext);

  if (status === 'loading') {
    return <CircularProgress size={10} />;
  }

  const appointment: Appointment | undefined = appointments[container.containerNumber];
  if (!appointment) {
    return null;
  }

  const appointmentInfo = getAppointmentStatus(container, appointment, 'pickupBookedAppointment');

  let content = null;
  switch (appointmentInfo.status) {
    case 'booked':
      content = <Scheduled appointmentInfo={appointmentInfo} />;
      break;
    case 'pending':
      content = <Book appointment={appointment} container={container} />;
      break;
    default:
      break;
  }

  return <div className="flex flex-col items-center space-y-1">{content}</div>;
};
Schedule.displayName = 'ContainerTable.PickupCell.Schedule';
